import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { FormBaseFormComponent, FormItem } from '../form-base-form/form-base-form.component';
import { FormBaseFormStore } from '../form-base-form/form-base-form.store';
import { FormSetEnum } from '../../../../../../../../../types/src/services/enum/form-set.enum';
import { msseKeys } from '@libs/shared/form-helpers/forms/forms-json-keys';
import { SelectInputComponent } from '../../../../../../components/kit/input/select-input/select-input.component';
import {
    TextAreaInputComponent,
} from '../../../../../../components/kit/input/text-area-input/text-area-input.component';
import { FormatPersonPipe } from '../../../../../shared/pipes/format-person.pipe';
import { DateInputComponent } from '../../../../../../components/kit/input/date-input/date-input.component';
import { ActionButtonsComponent } from '../../../../../../components/kit/action-buttons/action-buttons.component';

@Component({
    selector: 'app-form-msse-form',
    templateUrl: './form-msse-form.component.html',
    styleUrls: ['../form-base-form/form-base-form.scss'],
    providers: [FormBaseFormStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TranslatePipe,
        SelectInputComponent,
        TextAreaInputComponent,
        FormatPersonPipe,
        DateInputComponent,
        ActionButtonsComponent,
    ],
})
export class FormMsseFormComponent extends FormBaseFormComponent implements OnInit {

    public readonly translate = inject(TranslateService);

    constructor() {
        super();

        this.formUniqueIdentifier = FormSetEnum.MSSE;
        this.keys = msseKeys;

        this.options = [
            { value: true, name: this.translate.instant('yes') },
            { value: false, name: this.translate.instant('no') },
        ];

        const formConfig: FormItem[] = this.keys.map((key) => (
            { name: key, defaultValue: false, required: false }
        ));
        formConfig.push({ name: 'note', defaultValue: null, required: false });
        this.generateForm(formConfig);
    }

    override ngOnInit() {
        super.ngOnInit();
        if (!this.folderFormData) {
            this.generateFinalEvaluation({});
        }
    }
}
